function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function formatInline(value: string): string {
  let out = escapeHtml(value);
  out = out.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noreferrer">$1</a>');
  out = out.replace(/`([^`\n]+)`/g, "<code>$1</code>");
  out = out.replace(/\*\*([^\n*]+)\*\*/g, "<strong>$1</strong>");
  out = out.replace(/(^|[^\*])\*([^\n*]+)\*([^\*]|$)/g, "$1<em>$2</em>$3");
  return out;
}

export function renderSafeMarkdown(markdown: string): string {
  const lines = (markdown || "").split(/\r?\n/);
  const parts: string[] = [];
  let inList = false;

  for (const line of lines) {
    const bullet = line.match(/^\s*[-*]\s+(.+)$/);
    if (bullet) {
      if (!inList) {
        parts.push("<ul>");
        inList = true;
      }
      parts.push(`<li>${formatInline(bullet[1])}</li>`);
      continue;
    }

    if (inList) {
      parts.push("</ul>");
      inList = false;
    }

    if (!line.trim()) {
      parts.push("<br/>");
      continue;
    }

    parts.push(`<p>${formatInline(line)}</p>`);
  }

  if (inList) {
    parts.push("</ul>");
  }

  return parts.join("");
}
